<template>
  <div>
    <section id="content01">
      <Header/>
      <section id="content02" class="inner box_question">
          <video src="../assets/img/loading.mp4" playsinline muted autoplay loop>{{loadFunc()}}</video>
      </section>
    </section>
    <Footer/>
  </div>
</template>
<style scoped>
#content02{
    background-color: #FFF503;
    text-align: center;
    padding: 7% 0;
}
</style>
<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer_quest.vue'

export default {
  name: 'Calc',
  components: {
    Header,
    Footer
  },
  data:function(){
    return{
      checkedQuest:[],
    }
  },
  computed: {
    calcFunc:function(){
        let obj = this.$store.getters.answer
        let Sum = {};
        Object.keys(obj).forEach(function(element){
            //console.log(obj[element])
            Object.keys(obj[element]).forEach(function(elm){
                let id = obj[element][elm].id;
                let val = obj[element][elm].val;
                
                if(Object.prototype.hasOwnProperty.call(Sum,id)){
                    //すでにオブジェクト内にID存在しているので加算
                    Sum[id].val += val;
                }else{
                    //初めて現れたIDなので挿入
                    Sum[id] = ({'id':id,'val':val});
                }
            })
        })        
        console.log(Sum)
        this.$store.commit('incrementPoint',Sum)
        return Sum
        }
  },
  methods: {
      loadFunc:function(){
          this.calcFunc
          setTimeout(function(){
              this.$router.push('result')
          }.bind(this),5000)
      },
  }
}
</script>